// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "../application"

// Manually imported shared controllers
import LucideController from "../shared/lucide_controller"
application.register("lucide", LucideController)
import AutosizeController from "../shared/autosize_controller"
application.register("autosize", AutosizeController)
import PreventEnterSubmitController from "../shared/prevent_enter_submit_controller"
application.register("prevent-enter-submit", PreventEnterSubmitController)

// Auto-generated controller imports
import AnimateOnScrollController from "./animate_on_scroll_controller"
application.register("animate-on-scroll", AnimateOnScrollController)
import CheckboxRequiredController from "./checkbox_required_controller"
application.register("checkbox-required", CheckboxRequiredController)
import GalleryController from "./gallery_controller"
application.register("gallery", GalleryController)
import HeroController from "./hero_controller"
application.register("hero", HeroController)
import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)
import OptionalSectionController from "./optional_section_controller"
application.register("optional-section", OptionalSectionController)
